import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from '../Tabs/Tabs';
import FieldGroupsBuilderWorkspace from "./FieldGroupsBuilderWorkspace";

export default class FieldGroupBuilder extends React.Component {

  constructor(props) {
    super(props)

    this.state = { 
      active_tab: 'general',
      count: this.props.custom_fields && this.props.custom_fields.length ? this.props.custom_fields.length : 0,
      order: [],
      name: this.props.name ? this.props.name : '', 
      additional_customer_fields: this.props.additional_customer_fields ? this.props.additional_customer_fields : [],
      all_fields_groups: this.props.all_field_groups && this.props.all_field_groups.length ? this.props.all_field_groups : [],

    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
    this.onChangeFieldGroupName = this.onChangeFieldGroupName.bind(this)
    this.onChangeCustomFields = this.onChangeCustomFields.bind(this)
    this.onChangeOrder = this.onChangeOrder.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  /** Render Functions **/

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]

    return (
      <div className="AdditionalCustomerFieldBuilder" ref="form">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <FieldGroupsBuilderWorkspace
            {...this.props} 
            {...this.state} 
            onChangeCustomFields={this.onChangeCustomFields}
            onChangeOrder={this.onChangeOrder}
            onChangeFieldGroupName={this.onChangeFieldGroupName}/>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  tabs() {
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('custom_fields'),
          targetName: 'custom_fields',
          classes: this.state.active_tab === 'custom_fields' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );
  };

   /** Change Handlers **/

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab});
  }

  onChangeOrder(idsInOrder) {
    this.setState({order:idsInOrder})
  }
  
  onChangeFieldGroupName(event) {
    if (event && event.target) {
      var state = $.extend(true, {}, this.state);
      state[event.target.name] = event.target.value;
      this.setState(state);
    }
  }

  onChangeCustomFields(event) {
    if (event && event.target) {
      this.setState({additional_customer_fields: event.target.value})
    }
  }

  // /** AJAX Calls **/

  onSubmit() {
    var self = this  
    self.setState({ loading: true})
    setTimeout(function () {
      $.ajax({
        type: self.props.is_new ? 'POST' : 'PATCH',
        url: self.props.is_new ? self.props.create_path : self.props.save_path,
        data: {
          name: self.state.name,
          additional_customer_fields: self.state.additional_customer_fields.length > 0 ? JSON.stringify(self.state.additional_customer_fields) : [],
          order: self.state.order.length > 0 ? self.state.order : [],
        } 
      }).done(function (data) {
      
          if (parent && parent.refresh_data) {
            // console.log("R", self.props)
            if (self.props.is_new == true) {
              parent.refresh_data(I18n.t('field_group_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('field_group_saved_successfully'));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal()
          }
      
      })
    }, 1000)
  };
};
